export const sanitizeValues = (values, fallback) => {
    values = Array.isArray(values) ? values : [values];
    return values.map((v, i) => Number.isNaN(Number(v)) ? fallback[i] : Number(v));
};
export const isEqualContent = (array1, array2) => {
    let equal = array1.length === array2.length;
    for (let i = 0; equal && i < array2.length; i++)
        equal = array1[i] === array2[i];
    return equal;
};
export const elx = (...listeners) => (...args) => listeners.map((listener) => typeof listener === 'function' && listener(...args));
export const isRTL = (host) => {
    if (typeof window !== 'undefined') {
        return window.getComputedStyle(host).direction === 'rtl';
    }
    return Boolean(host.closest('[dir=rtl]'));
};
export const clamp = (num, min, max) => 
// eslint-disable-next-line no-nested-ternary
num > max ? max : num < min ? min : num;
